import { Injectable } from '@angular/core';
import { PonticDesignEnum } from '@shared/models/pontic-design.enum';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { IdName } from '@shared/models/id-name';

@Injectable({
	providedIn: 'root'
})
export class PonticSelectorService {
	constructor(private readonly shellQuery: ShellQuery) {}

	getSrcForPonticDesignImage(ponticDesign: IdName<PonticDesignEnum>): string {
		const ponticDesignSvgNames: Record<PonticDesignEnum, string> = {
			[PonticDesignEnum.RidgeLapPontic]: 'ridge-lap-pontic.svg',
			[PonticDesignEnum.ModifiedRidgeLapPontic]: 'modified-ridge-lap-pontic.svg',
			[PonticDesignEnum.SteinPontic]: 'stein-pontic.svg',
			[PonticDesignEnum.SanitaryPontic]: 'sanitary-pontic.svg',
			[PonticDesignEnum.OvalePontic]: 'ovale-pontic.svg'
		};

		// eslint-disable-next-line max-len
		return `${this.shellQuery.staticFilesEndpoint}/assets/pontic-designs/${ponticDesignSvgNames[ponticDesign.Id]}`;
	}

	getSrcForRadioButtonImg(): string {
		return `${this.shellQuery.staticFilesEndpoint}/assets/icons/check.svg`;
	}
}
